export default "__VITE_ASSET__CQWienoI__"